<template>
    <div style="height: 100%;width: 100%;display: inline-block;">
        <div style="position:relative;height:100vh" ref="fadeWhenModelOpen">
            <div class="d-flex" style="align-items:center">
                <div class="search-bar-comm-style pt-2 col-md-6" style="display: flex;">
                    <input
                        type="text"
                        class="rounded text-light search-bar"
                        :placeholder="$t('Search label')"
                        autocomplete="off" v-model="keyword" @input="getLinkTypesList(false)"/>
                </div>
                <div id="DAM-learn_about_screens" class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
                    <button class="btn btn-outline-primary m-2" @click="openLinkTypeCreateWindow('add-linktype')" style="float:inline-end">{{$t('Add')}}</button>
                </div>
            </div>

            <div style="height:inherit;display:inline-flex;width:100%">
                <div class="p-0 h-100" style="width:100%">
                    <div class="p-3" style="overflow: auto;width: 100%;height: calc(100% - 200px);">
                        <table class="tabletable-with-border table-scroll small-first-col table-cell-styles" style="background: transparent;width:98%;margin:0px 10px !important;">
                            <thead>
                                <tr style="height:40px">
                                    <th style="width:30%;text-align:start">{{$t('Name')}}</th>
                                    <th style="width:20%;text-align:start">{{$t('Outwards Description')}}</th>
                                    <th style="width:20%;text-align:start">{{$t('Inwards Description')}}</th>
                                    <th style="width:15%">{{$t('Created date')}}</th>
                                    <th style="width:15%;">{{$t('Modified date')}}</th>
                                </tr>   
                            </thead>
                            <tbody>
                                <template v-for="linkType in linkTypeDataList">
                                    <tr :key="linkType._id" class="comm-links-row show-delete-icon" @click="viewLinkTypeRequest(linkType)">
                                        <td style="text-align:start" class="link-name">{{linkType.link_name}}</td>  
                                        <td style="text-align:start">{{linkType.outward_desc}}</td>
                                        <td style="text-align:start">{{linkType.inward_desc}}</td> 
                                        <td :title="getDateAndTimeInConfiguredFormat(linkType.created_datetime)">{{getDateAndTimeInConfiguredFormat(linkType.created_datetime, true)}}</td>  
                                        <td :title="getDateAndTimeInConfiguredFormat(linkType.modified_datetime)">{{getDateAndTimeInConfiguredFormat(linkType.modified_datetime, true)}}
                                            <div>
                                                <svg @click.stop.prevent="deleteLinkTypeRequest(linkType._id, linkType.link_name)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash parent-comment-delete actions-icon" viewBox="0 0 16 16" style="margin-inline-start:10px;">
                                                    <title>{{$t('Delete')}}</title>
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                </svg>
                                                <svg @click.stop.prevent="viewLinkTypeRequest(linkType)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-pencil parent-comment-view actions-icon" style="margin-inline-start:10px;">
                                                    <title>{{$t('Edit')}}</title>
                                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z">
                                                    </path>
                                                </svg>
                                            </div>
                                        </td>  
                                    </tr>
                                </template>
                            </tbody>    
                        </table>
                    </div>  
                    <div>
                        <pagination
                            v-if="totalLinkTypes > -1"
                            v-model="currentPage"
                            :records="totalLinkTypes"
                            :per-page="linkTypesPerPage"
                            @paginate="paginate"
                            :options="options"
                            style="margin-top:10px"
                        />    
                    </div>      
                </div>    
            </div>    
        </div>
        <link-type-create-edit
            v-if="isLinkTypeCreateVisible"
            :dataToPopulate="linkTypeDataObj"
            @closeLinkTypeCreateWindow="closeLinkTypeCreateWindow"
            :isLinkTypeAllowedToEdit="isLinkTypeAllowedToEdit"
            @closeModal="closeModal">
        </link-type-create-edit>    
    </div>    
</template>

<script>
    import {mapActions, mapMutations} from 'vuex';
    import Utils from '../../components.utils.js';
    import {NotifierConstants} from "../../components.constants.js";
    import Pagination from "vue-pagination-2";
    import linkTypeCreate from "./AssetsLinksTypesCreateEditDialog.vue";

    export default{
        data(){
            return{
                isLinkTypeCreateVisible:false,
                linkTypeDataObj:{},
                isLinkTypeAllowedToEdit:false,
                linkTypeDataList : [],
                options:{chunk:5},
                currentPage:1,
                totalPages: -1,
                totalLinkTypes: -1,
                linkTypesPerPage: -1,
                keyword:"",
            }
        },
        components:{
            "link-type-create-edit":linkTypeCreate,
            pagination: Pagination,
        },
        methods:{
            closeLinkTypeCreateWindow(){
                this.isLinkTypeCreateVisible = false;
                this.isLinkTypeAllowedToEdit = false;
            },

            formatedDate(date){
                return Utils.getOnlyDateFormat(date);
            },

            formatDateAndTime(date){
                return Utils.getDateAndTimeFormat(date);
            },

            openLinkTypeCreateWindow(){
                this.isLinkTypeCreateVisible = true;
                this.isLinkTypeAllowedToEdit = false;
            },

            viewLinkTypeRequest(linkTypeData){
                this.linkTypeDataObj = linkTypeData;
                this.isLinkTypeCreateVisible = true;
                this.isLinkTypeAllowedToEdit = true;
            },

            closeModal(){
                this.isLinkTypeCreateVisible= false;
                this.isLinkTypeAllowedToEdit = false;
            },
            getLinkTypesList(onSearch = false){
                let payload = {params:{}};
                if(onSearch){
                    this.currentPage = 1
                }else if(this.currentPage > 1){
                    payload.params['page'] = this.currentPage
                }
                if(this.keyword && this.keyword.trim().length > 0){
                    payload.params = {"name":this.keyword}
                }
                this.getAssetLinkTypesFromServer(payload).then((data) =>{
                    this.linkTypeDataList = data["link_types"];
                    this.totalPages = data["page_count"];
                    this.currentPage = data["page"];
                    this.totalLinkTypes = data["total_link_types"];
                    this.linkTypesPerPage = data["link_types_per_page"];
                });
            },

            paginate(page) {
                this.currentPage = page;
                this.getLinkTypesList();
            },

            deleteLinkTypeRequest(linktypeId, linktypeName){
                if(typeof linktypeName == "undefined" || linktypeName.trim().length <= 0){
                    alert("Select Link to delete");
                    return;
                }
                let confMessage = "Are you sure you want to delete the selected Asset LinkType '"+linktypeName+"'?";
                let payload = {};
                payload["_id"] = linktypeId;
                this.isLinkAttachedToAnyAsset(payload).then((data)=>{
                    if(data.statusCode==200 && data.asset_linked){
                        confMessage = ""
                        alert(`Selected link type "${linktypeName}" is in use.\nPlease unset and proceed for delete.`);
                        return
                    }
                    if (confMessage.trim().length > 0 && confirm(confMessage)) {
                        this.deleteAssetLinkType(payload).then((data)=>{
                            if (Utils.isAcceptedStatusCode(data.statusCode)) {
                                if(data.message) this.$toast.success(data.message);
                            } else {
                                if(data.message) this.$toast.error(data.message);  
                            }
                        });
                    }else{
                        return false;
                    }
                })
            },
            handleNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let entry_info = notification.message
                    if ([NotifierConstants.AssetLinkTypeDeleted].includes(notification.message_type)){
                        let fIndex = this.linkTypeDataList.findIndex(item=>item._id == entry_info._id);
                        if(fIndex >= 0){
                            this.linkTypeDataList.splice(fIndex,1)
                        }
                    }else if([NotifierConstants.AssetLinkTypeUpdated].includes(notification.message_type)){
                        let fIndex = this.linkTypeDataList.findIndex(item=>item._id == entry_info._id);
                        if(fIndex >= 0){
                            this.linkTypeDataList[fIndex] = entry_info
                        }
                    }else if(notification.message_type == NotifierConstants.AssetLinkTypeCreated){
                        if(this.currentPage == 1){
                            setTimeout(()=>{
                                this.getLinkTypesList();
                            }, 100)
                        }
                    }
                }
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({eventname:[NotifierConstants.AssetLinkTypeCreated, NotifierConstants.AssetLinkTypeUpdated, NotifierConstants.AssetLinkTypeDeleted],callback:this.handleNotification,parent: "ManageAssetLinkTypes"})
            },
            UnregisterfromWebsocketNotifications(){
                this.removeWSEventListener({eventname:[NotifierConstants.AssetLinkTypeCreated, NotifierConstants.AssetLinkTypeUpdated, NotifierConstants.AssetLinkTypeDeleted],callback:this.handleNotification,parent: "ManageAssetLinkTypes"})
            },
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("assets", ["deleteAssetLinkType", "getAssetLinkTypesFromServer", "isLinkAttachedToAnyAsset"]),
        },

        created(){
            this.getLinkTypesList();
            this.registerforWebsocketNotifications();
        },
        beforeDestroy(){
            this.UnregisterfromWebsocketNotifications()
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
   $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;


    .table-scroll {
    /*width:100%; */
    border: none !important;
    /* Decoration */
    border-spacing: 0;
    margin: 0px 15px;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th {
            position: sticky;
            top: 0;
            background: $primary-background;
            z-index: 9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr {
            height: 45px;
            }
            tr:hover{
                background: $bg-color-on-hover !important;
            }
        }
    }

    .table {
        th {
            border-top: none !important;
            padding:0 10px !important;
        }
        td {
            border-top: none !important;
            padding:0 1rem!important;
        }
    }

    th {
        border-top: none !important;
        padding:0 10px !important;
    }

    .table-cell-styles{
        td{
            padding:0 10px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: $border-color;
        }
        tr {
            border-bottom: $border-color;
        }
    }

    .show-delete-icon{
        position: relative;
    }

    .show-delete-icon:hover{
        .parent-comment-delete,  .parent-comment-view{
            visibility: visible;
        }
    }

    .parent-comment-delete, .parent-comment-view{
        margin-inline-start: 10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 0px 5px 5px 0px;
        visibility: hidden;
    }

    .parent-comment-view{
        inset-inline-end:54px;
        border-radius: 5px 0px 0px 5px;
    }

    ::v-deep{
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-end;
            margin-inline-start:5px;
            position: relative;
            top:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
    }
    .comm-links-row:hover{
        :not(.link-name), :not(.comm-links-row:last-child), :not(.actions-icon){
            color: $active-blue;
            background: $bg-color-on-hover;
        }
        td:first-child {
            :not(.link-name){
                text-decoration: underline;
            }
        }
    }
    .search-bar-comm-style {
      margin-top: 5px;
      display:inline-flex;
      .search-bar{
        background: $primary-background !important;
        height:40px;
        width: 250px !important;
        float: inline-start;
        padding-inline-start: 12px;
        margin: 0;
        margin-inline-end: 3%;  
        padding-bottom:2px;
        border: $border-color !important;
      }
    }
</style>